const SET_LIST = (state, payload) => {
  state.list = payload
}

const SET_PERMISSIONS = (state, payload) => {
  state.permissions = payload
}

const SET_ERRORS = (state, payload) => {
  state.errors = { ...payload }
}

const RESET_ERRORS = (state) => {
  state.errors = { ...state.initialErrors }
}

export default {
  SET_LIST,
  SET_PERMISSIONS,
  SET_ERRORS,
  RESET_ERRORS
}



// WEBPACK FOOTER //
// ./src/features/user/store/mutations.js